<template>
 <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-column flex-lg-row flex-stack">
        <AppViewHeader :title="title" :breads="breadcrumbs"/>
        <div class="d-flex align-items-center gap-2 gap-lg-3 flex-column flex-lg-row">
            <DateRangePicker id="dashboard-daterangepicker" @update:date="handleRangeDate" />
            <Button icon-class="fas fa-backspace" btn-class="btn-sm" type="cancel" btn-text="back" @click="router.go(-1)"/>
        </div>
      </div>
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div id="kt_content_container" class="container" style="max-width: 1600px">
        <div class="card shadow-sm mb-5 p-5 px-10">
          <div class="d-flex justify-content-start align-items-center mt-2">
            <h3 class="mt-1">{{society?.name}}</h3>
            <span class="ms-5">{{$t('absences.select_office')}}</span>
          </div>
          <div class="row mt-5 pt-5">
            <OfficeCountCard class="mb-4"  v-for="office in offices" attr="holidays_count" :key="office.id" :office="office" v-model="activeOfficeId"/>
          </div>
        </div>

         <div v-if="$can(abilities.VIEW_STAT_HOLIDAY)" class="card shadow-sm mb-5 p-5 px-10">
            <h1>{{$t('absences.stat_absences')}}</h1>
            <div class="mt-5">
              <div class="row">
                <div class="col-md-6 col-lg-4 mb-5" v-for="(stat, key) in statistics" :key="key">
                  <div class="card card-body me-lg-5 shadow">
                    <div class="d-flex flex-stack">
                      <div class="symbol symbol-30px me-4">
                        <div class="symbol-label fs-2 text-white" :class="'bg-'+stat.color">
                          {{stat.count}}
                        </div>
                      </div>
                      <div class="flex-row-fluid flex-wrap">
                        <div class="mb-2">
                          <a class="text-gray-800 fs-6 fw-bolder">
                            {{stat[locale]}}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end py-5">
            <Button type="new" btn-class="btn-md me-5" iconClass="fas fa-umbrella-beach fs-5 me-3" @click="openRemainingHolidaysModal" btn-text="absences.user_list_nbr_holiday"></Button>
            <Button type="new" v-if="route.query.viewType === modelViewType.list || !route.query.viewType" @click="changeModelViewType(modelViewType.list)" iconClass="fas fa-list fs-5 me-3" btn-class="btn-sm me-5 fs-5" btn-text="absences.list_view"></Button>
            <OutlineButton type="primary" v-if="route.query.viewType === modelViewType.list || !route.query.viewType" @click="changeModelViewType(modelViewType.calendar)" :border="true" btn-class="btn-sm fs-5" btn-text="absences.calendar_view" iconClass="fas fa-calendar fs-5 me-3" />
            <OutlineButton type="primary" v-if="route.query.viewType === modelViewType.calendar" @click="changeModelViewType(modelViewType.list)" :border="true" btn-class="btn-sm me-5 fs-5" btn-text="absences.list_view" iconClass="fas fa-list fs-5 me-3" />
            <Button type="new" v-if="route.query.viewType === modelViewType.calendar" @click="changeModelViewType(modelViewType.calendar)" iconClass="fas fa-calendar fs-5 me-3" btn-class="btn-sm fs-5" btn-text="absences.calendar_view"></Button>
          </div>

          <div v-if="route.query.viewType === modelViewType.list || !route.query.viewType">
            <ListAbsences @loadStat="loadStatisticQuery" :filterDate="query" :officeId="activeOfficeId"/>
          </div>

          <div v-if="route.query.viewType === modelViewType.calendar">
            <CalendarAbsences :dates="query" :office="activeOfficeId"/>
          </div>
      </div>
    </div>
    <UserListHolidays id="remaining_holidays_modal" :societyOfficeId="activeOfficeId"/>
  </div>
</template>
<script setup> 
import {onMounted, ref, computed, watch, nextTick} from "vue";
import {useStore} from "vuex";
import {$formatLocalAmount} from "@/mixins/Helpers";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";
import {useLocales} from "@/composables/locales";
import DateRangePicker from "@/components/DateRangePicker.vue";
import Button from "@/components/Button";
import i18n from "@/plugins/i18n";
import {useRouter, useRoute} from 'vue-router';
import Input from "@/components/Input.vue";
import {formattedLocalAmount} from "@/mixins/Helpers";
import ButtonDropdownFilter from "@/components/ButtonDropdownFilter.vue";
import {useHasAbility} from "@/composables/hasAbility";
import Card from "@/Modules/CRM/components/Card";
import abilities from "@/composables/abilities";
import {Theme} from "@/composables/theming";
import OutlineButton from "@/components/OutlineButton.vue"
import ListAbsences from "./List"
import {useModelViewType} from "@/composables/modelViewType";
import CalendarAbsences from "./Calendar"
import UserListHolidays from "./Modals/UserListHolidays"
import AppViewHeader from "./Component/AppViewHeader"
import OfficeCountCard from "@/components/OfficeCountCard.vue";

const store = useStore()
const router = useRouter()
const route = useRoute()

const { can } = useHasAbility()
const { locale } = useLocales()

const activeOfficeId = ref(route.params.id)

const title = ref("absences.title")
const breadcrumbs = ref([
    {
      name: 'Dohler West Africa',
      path: '/admin/rh/absences'
    }
])

const query = ref({
  start_date: '',
  end_date: ''
})
const isLoading = ref(true)

const { modelViewType } = useModelViewType()
const statistics = ref({})

const offices = computed(() => store.getters['absences/getSocietyOfficesHolidays'])
const society = computed(() => store.getters['offices/getSelectedCompany'])
const currentCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])

watch(() => society.value, (value) => {
  loadSocietyData()
})

watch(() => offices.value, (value) => {
  if(!value?.map(x=> x.id)?.includes(route.params.id)){
    activeOfficeId.value = value[0]?.id
  }else{
    activeOfficeId.value = route.params.id
  }
})

watch(() => activeOfficeId.value, (value) => {
  let office = offices.value.find(o => o.id === value);
  breadcrumbs.value[0].name = office?.name || ""
  loadStatisticQuery()
})

watch(() => query.value.start_date, (value) => {
  loadStatisticQuery()
})

watch(() => query.value.end_date, (value) => {
  loadStatisticQuery()
})

function changeModelViewType (viewType) {
  router.push({ query: { viewType } });
}

watch(() => currentCompanyId.value,  (value) => {
  if(value){
    loadOffices()
    router.replace({name: route.name, params : { id : activeOfficeId.value }})
  }
})

async function loadStatisticQuery() {
  if(can(abilities.VIEW_STAT_HOLIDAY)) {
    let data = {
      startDate: query.value.start_date,
      endDate: query.value.end_date,
      office_id: activeOfficeId.value
    }
    await store.dispatch('absences/getAbsencesManageStatistics', data).then((res) => {
      statistics.value = res?.data?.stats
    })
  }
} 


function openRemainingHolidaysModal(){
  $('#remaining_holidays_modal').modal('toggle')
}

function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
}

function loadSocietyData() {
  if(society.value){
    store.dispatch('absences/loadSocietyOfficesHolidays', society.value?.id)
  }
}

 function loadOffices () {
  store.dispatch('offices/loadOfficesBySocieties')
}

onMounted(() => {
  loadSocietyData()
  loadOffices()
  loadStatisticQuery()
})
</script>

<style scoped>
  .grey-background {
    background-color: #f0f0f0;
  }
  .stat_class {
    background-color: var(--bs-light-primary);
    border-radius: 8px;
    padding: 5px;
    width: auto;
  }
</style>
